import { ca } from 'vuetify/lib/locale'

export default {
  ...ca,
  lang: "Català",
  
  login: "Inicia sessió",
  logout: "Tancar sessió",

  //User
  username: "Nom d'usuario",
  email: "Correu electrònic",
  password: "Contrasenya",

  user: "Usuari",
  user_menu: {
    process_map_image: "Imatge Mapa Processos",
    change_password: "Canviar Contrasenya",
  },

  inactivity_title: "AVÍS D'INACTIVITAT",
  check_inactivity_warning_1: "La vostra sessió està a punt de caducar. Si voleu continuar a la pàgina feu clic a Continua.",
  check_inactivity_warning_2: "Segons per a desconnexió automàtica: ",
  
  identify: "Identifica't",
  add: "Afegir",
  delete: "Eliminar",
  search_text: "Cerca...",
  loading: "Carregant...",
  select: "Seleccionar",
  select_all: "Seleccionar tots",
  limit: "Límit",
  type: "Tipus",
  confirm: "Sí",
  denny: "No",
  not_found: "No trobat",
  text_new: "Nou",
  text_modify: "Modificat",
  text_equal:"Igual",
  text_legend:"Llegenda",
  max_file_size_reached: "S'ha arribat al pes màxim dels arxius del formulari (19Mb).\n Elimini algun arxiu o redueix el seu tamany.",

  labels: {
    name: "Nom",
    description: "Descripció",
    weight: "Pes",
    number: "Número",
    units: "Unidades",
    document: "Document",
    report: "Informe",
    report_list: "Llistat",
    parent_roles_inheritance: "Herència dels rols dels pares",
  },

  dialog: {
    save: "Guardar",
    cancel: "Cancel·la",
    send: "Enviar",
    clear: "Netejar",
    delete: "Esborrar",
    confirm: "Confirma",
  },

  filters: {
    processes: {
      process: "Filtre de processos",
      processes_selected: "Processos seleccionats",
    },
    dates: {
      date_range: "Escollir rang de dates",
      dates_selected: "Dates seleccionades",
      date_field: "Escollir Camp",
      date1_lower: "La data final no pot ser menor que la d'inici",
    },
    advanced: {
      filters: "Filtres",
      title: "Condicions del filtre",
    },
    type: "Filtre de tipus",
  },

  week_days: {
    monday: "Dilluns",
    tuesday: "Dimarts",
    wednesday: "Dimecres",
    thursday: "Dijous",
    friday: "Divendres",
    saturday: "Dissabte",
    sunday: "Diumenge",

    short: {
      monday: "Dl",
      tuesday: "Dt",
      wednesday: "Dc",
      thursday: "Dj",
      friday: "Dv",
      saturday: "Ds",
      sunday: "Dg",
    }
  },

  month_names: {
    january: "Gener",
    february: "Febrer",
    march: "Març",
    april: "Abril",
    may: "Maig",
    june: "Juny",
    july: "Juliol",
    august: "Agost",
    september: "Setembre",
    october: "Octubre",
    november: "Novembre",
    december: "Desembre",
  },

  monthly: "Mensual",
  weekly: "Setmanal",
  daily: "Diari",

  go_to_today: "Anar a avui",
  calendar_type: "Mode de visualització actual",
  current_day_interval: "Interval de dies actual",

  no_process_map: "No hi ha cap mapa de processos configurat",
  required_field: "Camp obligatori",
  duplicate_value: "El valor no és vàlid. Duplicat",
  copied: "Copiat",

  invalid_value: "Valor invàlid",
  invalid_date: "Data invàlida",
  invalid_hour: "Hora invàlida",
  invalid_minute: "Minuts invàlids",
  invalid_negative_number: "No s'admeten números negatius",
  bigger_than: "El valor ha de ser més gran de",
  smaller_than: "El valor ha de ser menor de",

  password_form: {
    current_password: "Contrasenya",
    new_password: "Nova contrasenya",
    confirm_new_password: "Confirmar nova contrasenya",

    input_current_password: "Introduir contrasenya actual",
    input_new_password: "Introduir nova contrasenya",
    reinput_new_password: "Reintroduir nova contrasenya",
    pattern_error: "Mín. 8 caràcters amb almenys una lletra majúscula, un número i un caràcter especial.",
    password_no_match: "Els camps no coincideixen",
    password_different: "La contrasenya nova ha de ser diferent de l'anterior",
  },

  notifications: {
    title: "Notificacions d'usuari",
  },

  pagination: {
    page: "Elements per pàgina",
    page_mobile: "Pàgina",
    of: "de",
  },

  explorer: {
    no_data: "No s'han trobat resultats",
    no_views: "No hi ha vistes disponibles",
  },

  views: {
    table: "Taula",
    cards: "Targetes",
    calendar: "Calendari",
    charts: "Gràfics",
    processes: {
      tabs: {
        data: "Dades",
        permissions: "Permisos"
      },
      add_process: "Afegir procés",
      edit_process: "Editar procés",
      delete_process: "Eliminar procés",
      add_permission: "Afegir permís",
      edit_permission: "Editar permís",
      delete_permission: "Eliminar permís",
      process_fields: {
        process_id: "Id",
        internal_type: "Tipus de procés intern",
        internal_type_placeholder: "Seleccione tipo de proceso interno",
        bp_reference: "Referència interna",
        bp_reference_placeholder: "Introducir referencia interna del proceso",
        inherit_permissions: "Hereta permisos",
        inherit_permissions_placeholder: "Seleccioneu si el procés hereta rols/permisos",
        reference: "Referència",
        reference_placeholder: "Introduir referència del procés",
        name: "Nom",
        name_placeholder: "Introduir nom del procés",
        process_type: "Tipus de procés",
        process_type_placeholder: "Seleccioneu Tipus de procés",
        description: "Descripció",
        description_placeholder: "Introduir descripció del procés",
        entries: "Entrades",
        entries_placeholder: "Introduir entrades del procés",
        outputs: "Sortides",
        outputs_placeholder: "Introduir sortides del procés",
        activities: "Activitats",
        activities_placeholder: "Introduir activitats del procés",
        objective: "Objectiu",
        objective_placeholder: "Introduir objectiu del procés",
        scope: "Abast",
        scope_placeholder: "Introduir abast del procés",
        process_roles_text: "ROLS DEL PROCÉS",
        responsible_roles: "Rols responsables del procés",
        responsible_roles_placeholder: "Seleccionar rols responsables del procés",
        creator_roles: "Rols que poden crear",
        creator_roles_placeholder: "Seleccionar rols que poden crear QUnits que implementen el procés",
        editor_roles: "Rols editor del procés",
        editor_roles_placeholder: "Seleccionar rols que poden executar totes les transicions dels QUnits que implementin el procés",
        reader_roles: "Rols lectors del procés",
        reader_roles_placeholder: "Rols que poden llegir tots els QUnits que implementin el procés. Descàrrega PDF",
        original_document_reader_roles: "Rols lectors del procés. Descarregar original",
        original_document_reader_roles_placeholder: "Rols que poden llegir tots els QUnits que implementin el procés. Descarregar original",
        visor_pdf_reader_roles: "Rols lectors del procés. Només visor PDF",
        visor_pdf_reader_roles_placeholder: "Rols que poden llegir tots els QUnits que implementin el procés. Només visor PDF",
        parent: "Pare",
      },
      permission_fields: {
        permission_id: "Id. permís",
        roles_allowed: "Rols autoritzats",
        departments_allowed: "Departaments autoritzats",
      },
      process_types: {
        core: "Clau",
        strategic: "Estratègic",
        support: "De Suport",
       },
       internal_type: {
        public: "Públic",
        restricted: "Restringit",
       },
       standard: {
        add: "Afegir estàndard",
        name_placeholder: "Introduir nom de l'estàndard"
       },
    },
  },

  inputs: {
    directory: "Carpeta",
    current_file: "Archiu actual",
    file_too_big: "La mida ha de ser menor de 20 MiB!",
    file_type_not_identified: "No es pot identificar el tipus de fitxer",
    file_not_valid: "El fixer no és vàlid",
    email_invalid: "El correu electonic no és valid",
    start_space: "Té un espai al principi",
    link_invalid: "L'enllaç no és vàlid",
  },

  indicators: {
    weight: "Pes",
    measure_type: "Seleccioneu el tipus de mesura",
    new_measure: "Nou mesura",
    percentage: "Percentatge",
    invalid_percentage: "Percentatge invàlid",
    indicator_label: "Indicador",
    new_measure_modal: "Mesuras: Nou mesura",
    measures_types_names: {
      "category": "Categòrica",
      "number": "Numèrica",
      "indicator": "Sub-indicador",
    },
    variable_type: "Tipus de variable",
    allow_negative: "Permetre valors negatius",
    units_placeholder: "Nom de la unitat. Ex: kg, m, l, kW/h...",
    num_types: {
      integer: "Enter",
      decimal: "Decimal",
      },
  },

  directory: {
    directory: "Carpeta",
    no_directory: "No s'han trobat carpetes",
    add_directory: "Afegir carpeta",
    add_subdirectory: "Afegir subcarpeta",
    edit_directory: "Editar carpeta",
    delete_directory: "Esborrar carpeta",
    father: "Pare",
    select_father: "Seleccioneu la carpeta pare",
    directory_name: "Nom",
    select_parent_directory: "Seleccioneu la carpeta pare",
    not_able_to_delete: "No es pot esborrar la carpeta",
    level: "Nivell",
    route: "Ruta",
  },

  footer: {
    contact: "Contacte",
    help: "Ajuda",
  },

  actions: {
    generic_download_evidence_options: {
      current_version: "Versió vigent",
      draft: "Borrador",
    },
    view_qunit: {
      data: "Dades",
    },
  },

  inlineboxes: {
    inlinebox_data: {
      copy_email: "Copiar codi email",
      responsible: "Responsable",
    },
  },

  chips: {
    value: "Valor",
    process: "Proceso",
  },

  reports:{
    info:"El vostre llistat s'està generant ...",
    success: "El llistat ha estat generat",
    error: "Error: no es va poder generar el llistat",
  },

  indicator: {
    numbers: "Nombres",
    int: "enters",
    float: "decimals",
    positive: "positius",
    units: 'Unitats',
  },
};
